"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _log = _interopRequireDefault(require("./log.js"));

var _ampConfig = _interopRequireDefault(require("./services/amp-config.js"));

var _config = _interopRequireDefault(require("./config.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ampConfig = null;

var fetchConfig = function fetchConfig() {
  if (ampConfig) {
    return Promise.resolve(ampConfig);
  } else {
    return _ampConfig["default"].fetchAmpConfig().then(function (config) {
      ampConfig = config;
      return ampConfig;
    });
  }
};

var get = function get(name) {
  // windows not available when used as a back-end services.
  if (typeof window !== 'undefined') {
    var storedConfig = window.localStorage.getItem("ampConfig.".concat(name));

    if (storedConfig !== null) {
      return Promise.resolve(storedConfig);
    }
  } // the requested value is overwritten, just return that.


  var overrideValue = _config["default"].get(name);

  if (overrideValue !== undefined) {
    return Promise.resolve(overrideValue);
  }

  return fetchConfig().then(function (config) {
    if (config[name]) {
      return config[name];
    } else {
      _log["default"].error("amp-config does not contain \"".concat(name, "\""));
    }
  });
};

var _default = {
  get: get
};
exports["default"] = _default;